import type { OpcionCampo } from '../../lib/sesion';

/**
 * Selector del ancla de evaluación (ADR-0005 §3): cuando la captura declara
 * `sobre`, el aporte evalúa UN elemento concreto de la actividad fuente (un
 * boceto, una idea, una tarea). Todo lo necesario está EN el Bolsillo — la
 * Pantalla agrega y ritma, no instruye (anti-patrón de atención dividida).
 */
export function SobreSelector({
  opciones,
  valor,
  onElegir,
  deshabilitado,
  etiqueta = '¿Sobre cuál?',
}: {
  opciones: OpcionCampo[];
  valor: string | null;
  onElegir: (valor: string) => void;
  deshabilitado: boolean;
  etiqueta?: string;
}) {
  if (!opciones.length) return null;
  return (
    <div className="flex flex-col gap-2">
      <span className="font-sans text-sm font-medium text-content">{etiqueta}</span>
      <div className="flex flex-col gap-2" role="radiogroup" aria-label={etiqueta}>
        {opciones.map((op) => {
          const elegido = valor === op.valor;
          return (
            <button
              key={op.valor}
              type="button"
              role="radio"
              aria-checked={elegido}
              disabled={deshabilitado}
              onClick={() => onElegir(op.valor)}
              className={`flex min-h-touch items-center rounded-lg border px-3 py-2 text-left font-sans text-sm font-medium text-content transition-colors duration-fast focus-visible:outline-none focus-visible:shadow-focus disabled:opacity-50 ${
                elegido
                  ? 'border-primary bg-surface-sunken'
                  : 'border-border-strong bg-surface-raised hover:border-primary hover:bg-surface-sunken'
              }`}
            >
              <span className="min-w-0 flex-1">{op.etiqueta}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
